"use client";

import { CcDemoTabs } from "@/components/services/shared/CcDemoTabs";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";
import { devSectionAttr } from "@/lib/dev/section-attr";

import type { AiValueDemoCopy } from "./ai-value-demo-copy";
import {
  AiAnswersPhotoView,
  AiLeadsPhotoView,
  AiSourcesPhotoView,
} from "./CcAiValuePhotoViews";

type CcAiValueProps = {
  copy: AiValueDemoCopy;
};

/**
 * "Värdet av AI-synlighet": three tabs following one made-up company (named
 * in the answers → the right sources → more enquiries), each a real photo of
 * a person with realistic cards and the real AI services' logos over it.
 * Same section layout and styles as the SEO and webbyrå value demos.
 */
export function CcAiValue({ copy }: CcAiValueProps) {
  return (
    <section
      className="cc-section cc-seo-value"
      aria-labelledby="cc-ai-value-title"
      data-cc-nav="light"
      {...devSectionAttr("ai-value")}
    >
      <div className="cc-container">
        <header className="cc-seo-value__header">
          <CcSanjayaEyebrow theme="on-subtle">{copy.eyebrow}</CcSanjayaEyebrow>
          <h2 id="cc-ai-value-title" className="cc-seo-heading">
            {copy.title}
          </h2>
          <p className="cc-seo-lead cc-seo-value__lead">{copy.lead}</p>
        </header>

        <CcDemoTabs
          tablistLabel={copy.tablistLabel}
          disclaimer={copy.disclaimer}
          tabs={[
            {
              key: "answers",
              label: copy.tabs.answers,
              summary: copy.answers.summary,
              content: <AiAnswersPhotoView copy={copy.answers} />,
            },
            {
              key: "sources",
              label: copy.tabs.sources,
              summary: copy.sources.summary,
              content: <AiSourcesPhotoView copy={copy.sources} />,
            },
            {
              key: "leads",
              label: copy.tabs.leads,
              summary: copy.leads.summary,
              content: <AiLeadsPhotoView copy={copy.leads} />,
            },
          ]}
        />

        <p className="cc-seo-value__footnote">{copy.footnote}</p>
      </div>
    </section>
  );
}
